"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ open, closeDialog }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const categoryList = (0, _1.useCategoryList)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CategoryDialog, Object.assign({ open: open }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, id: "category_dialog_header" }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: closeDialog }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) })), t('무엇을 판매하시나요?')] })), (0, jsx_runtime_1.jsx)(_1.CategoryScroll, { categoryList: categoryList }), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, className: "sticky-btn-bg", id: "complete_btn_wrapper" }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "orange_filled", fullWidth: true, onClick: closeDialog, sx: { borderRadius: '12px' } }, { children: t('선택 완료') })) }))] })));
}
exports.default = default_1;
const CategoryDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-scrollPaper {
    align-items: flex-end;
  }
  .MuiDialog-paper {
    width: 100%;
    max-width: 480px;
    height: 88%;
    border-radius: 20px 20px 0 0;
    margin: 0;
  }
  #category_dialog_header {
    height: 56px;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 17px;
    .MuiIconButton-root {
      position: absolute;
      left: 12px;
    }
  }
  #complete_btn_wrapper {
    position: fixed;
    bottom: 0;
    width: calc(100% - 32px);
    max-width: calc(480px - 32px);
    padding: 60px 0 32px;
    margin: 0 16px;
  }
`;
